<template>
 <!-- 常用车辆 列表-->
  <div>
    <el-row>
      <el-col :span="24">
        <!-- 查询条件 -->
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="车牌号">
            <el-input v-model.trim="searchForm.licensePlateNum" clearable placeholder="车牌号" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSearch">查询</el-button>
            <el-button type="primary" @click="getToAddPath">新增</el-button>
          </el-form-item>
        </el-form>
        <Tables :columns="columns" :loading="loading" :tableData="tableData">
          <template #emissionStandard="scope">
            <div>{{ changeKeyToName(emissionStandardList,scope.row.emissionStandard) }}</div>
          </template>
          <template #actions="scope">
            <!-- <el-button type="text" size="small" @click="getEdit(scope.row)">环保备案</el-button> -->
            <el-button type="text" size="small" @click="getEditCar(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="delCar(scope.row)">删除</el-button>
          </template>
        </Tables>
        <!-- 分页 -->
        <Pages :pageData="pageData" :sizeChange="sizeChange" :currentChange="currentChange"/>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import  { columns } from './columns'
import  { changeKeyToName,emissionStandardList } from '@/components/commonVehicles/columns'
import {timerTwo} from '@/assets/js/time'
export default {
  props:{
    //工作台类型
    workType:{
      type: String,
    },
  },
  data() {
    return {
      columns,emissionStandardList,
      // 是否加载
      loading: false,
      // 表格数据
      tableData: [],
      // 分页数据
      pageData: {
        page:1,
        size:10,
        total:0
      },
      // 查询参数
      searchForm:{
         licensePlateNum:''
      }
    
    };
  },
  created() {
    this.getCarList();
  },
  methods: {
    changeKeyToName,
    //备案
    getEdit(row) {
      let paramsData={
        // licensePlateNum:row.licensePlateNum
      }
      this.$api.carrier.carRecord(paramsData).then(res=>{
      })
      this.$router.push({ name: 'carrierWorkbench_commonVehiclesDetails', query: { carDetail: JSON.stringify(row) }})
    },
    // 新增
    getToAddPath(){
      if(this.workType=='客户工作台'){
        this.$router.push('/customerWorkbench/addComCar')
      }else if(this.workType=='承运商工作台'){
        this.$router.push('/carrierWorkbench/addComCar')
      }else if(this.workType=='原料供应商工作台'){
        this.$router.push('/supplierWorkbench/addComCar')
      }else if(this.workType=='物资供应商工作台'){
        this.$router.push('/materialSuppliers/commonVehicles/addComCar')
      }
    },
    // 编辑车辆
    getEditCar(val){
      if(this.workType=='客户工作台'){
        this.$router.push({ name: 'customerWorkbench_addComCar', query:{ carDetail: JSON.stringify(val) }})
      }else if(this.workType=='承运商工作台'){
        this.$router.push({ name: 'carrierWorkbench_addComCar', query:{ carDetail: JSON.stringify(val) }})
      }else if(this.workType=='原料供应商工作台'){
        this.$router.push({ name: 'supplierWorkbench_addComCar', query:{ carDetail: JSON.stringify(val) }})
      }else if(this.workType=='物资供应商工作台'){
        this.$router.push({ name: 'materialSuppliers_commonVehicles_addComCar', query:{ carDetail: JSON.stringify(val) }})
      }
      
    },

    // 删除车辆
    delCar(val) {
      let paramsData = {
        lpCc: val.lpCc,
      };
      this.$confirm('确定删除该车辆吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        this.$api.carrier.delCommonVehicle(paramsData).then((res) => {
          if (res.status == 200) {
            this.$message.success(res.data);
            this.getCarList();
          }else{
            this.$message.error(res.msg)
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });          
      });

    },
    // 查询
    onSearch() {
      this.pageData = {
        size: 10,
        page: 1,
        total: 0,
      }
      this.getCarList();
    },
    // 车辆列表查询
    getCarList() {
      let paramsData={
        page:this.pageData.page,
        size:this.pageData.size,
        licensePlateNum:this.searchForm.licensePlateNum
      }
      this.$api.carrier.postcommonVehicle(paramsData).then((res) => {
        // console.log(res,'常用车辆列表')
        if(res.status == 200){
          this.pageData.total = res.data.totalCount;
          res.data.information.forEach(item=>{
            item.createTime=timerTwo(item.createTime)
            item.updateTime=timerTwo(item.updateTime)
          })
          this.tableData = res.data.information;
        }else{
          this.$message.error(res.msg);
        }
      });
    },
    sizeChange(size) {
      this.pageData.size = size;
      this.getCarList();
    },
    currentChange(page) {
      this.pageData.page = page;
      this.getCarList();
    },
  },
};
</script>
<style scoped></style>
